import { cn } from "@/lib/utils"

interface LogoProps {
  size?: "sm" | "md" | "lg"
  /** navy wordmark (for light backgrounds) or white wordmark (for navy). */
  variant?: "navy" | "white"
  className?: string
}

// The official El HaDegel logo — wordmark + two-tone Magen David + tagline,
// vector (extracted from elhadegel.co.il). Ratio ~226:63; sized by height.
export function Logo({ size = "md", variant = "navy", className }: LogoProps) {
  const h = size === "sm" ? "h-9" : size === "lg" ? "h-14" : "h-11"
  return (
    <img
      src={`/logo/el-hadegel-logo-${variant}.svg`}
      alt="אל הדגל"
      className={cn(h, "w-auto select-none", className)}
      draggable={false}
    />
  )
}
